module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/lines/wall/textures/bricks.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/lines/wall/textures/bricks.jpg
// module id = 465
// module chunks = 0